import { PostSource, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from '../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import { postCompositionConfigFilmStrip } from '../../components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultPosition } from '@sprinklr/display-builder/stores/PanelTemplatesStore/PanelTemplatesTheme/constants';

export const TemplateFilmStrip: Panel = {
    id: 'filmstrip',
    name: 'Film Strip',
    description: '',
    tags: ['Content', 'Posts', 'Film Strip', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_film_strip',
        children: [
            {
                type: 'postsFilmStrip',
                id: '1',
                name: 'film_strip',
                useGlobalTimePeriod: true,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                // Note: All global variables like reportingEngine, report, and filters
                                // are injected via PostRequest.getRequests()
                                id: new PostSource({
                                    pageSize: 18,
                                    sorts: [
                                        new Sort({
                                            order: 'DESC',
                                            heading: {
                                                MONITORING_DASHBOARD: 'REACH_COUNT',
                                                LISTENING: 'REACH_COUNT',
                                                INBOUND_MESSAGE: 'INBOUND_COUNT',
                                                PLATFORM: 'TOTAL_ENGAGEMENT',
                                                BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                                CAMPAIGN: 'OUTBOUND_STATUS',
                                                RDB_FIREHOSE: 'SN_CREATED_TIME',
                                                STORY_MESSAGE: 'IMPACT',
                                            },
                                        }),
                                    ],
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        key: 'last_7_days',
                                    },
                                }) as any,
                                options: {
                                    count: 200,
                                    imagePreload: true,
                                    removeDuplicates: true,
                                    includeFaceDetection: false,
                                    shufflePosts: false,
                                    removeSensitivePosts: true,
                                    includeQuoteTweets: false,
                                },
                            },
                        ],
                        format: {
                            type: 'window',
                            options: {
                                padding: 3,
                            },
                        },
                    },
                ],
                position: DefaultPosition,
                options: {
                    player: {
                        playing: true,
                        duration: 6,
                    },
                    postVersion: 2,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    nativeStyling: {
                        retweetIndicator: true,
                    },
                    ...postCompositionConfigFilmStrip.a,
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    imageFaceDetection: false,
                },
                label: {
                    titleText: 'Film Strip',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
            },
        ],
        theme: {
            ext: {
                padding: 0,
            },
        },
    },
};
